<template>
  <div>
    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <template #sidebar>
        <Heading element="h2" class="sidebar-title">
          Ações da página
        </Heading>
        <div class="button">
          <Button
            :disabled="disabledSave"
            tooltipText="Selecione um hotel e acrescente um nome para salvar."
            class="button--save"
            @click="saveAction"
          >
            Salvar
          </Button>
          <Button
            layout="outline"
            class="button--return"
            @click="$router.push({ path: '/regioes' })"
          >
            Voltar sem salvar
          </Button>
        </div>
      </template>
      <template #content>
        <div class="input">
          <Heading element="h4" class="input--title">
            Nome da região
          </Heading>

          <input
            v-model="regionName"
            placeholder="Insira o nome da região"
            type="text"
            class="input--box"
          />
        </div>
        <SelectionBox
          v-model="selectedHotels"
          :list="hotelsList"
          titleFirstBox="Hotéis sem região"
          titleSecondBox="Hotéis selecionados"
          class="selection-box"
        >
        </SelectionBox>
        <span class="bottom-action">
          <Button
            layout="outline"
            class="bottom-action--button"
            @click="$router.push({ path: '/regioes' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            :disabled="disabledSave"
            tooltipText="Selecione um hotel e acrescente um nome para salvar."
            class="bottom-action--button__save"
            @click="saveAction"
          >
            Salvar
          </Button>
        </span>
      </template>
    </SidebarLayout3>
  </div>
</template>

<script>
import Button from '@/components/_base/elements/Button'
import Heading from '@/components/_base/elements/Heading'
import SelectionBox from '@/components/_base/patterns/SelectionBox'
import SidebarLayout3 from '@/layouts/SidebarLayout3'

export default {
  name: 'RegionsCreate',
  components: {
    Button,
    Heading,
    SelectionBox,
    SidebarLayout3
  },
  data() {
    return {
      /** Caminho de pão */
      breadcrumb: [
        {
          url: '',
          label: 'Configurações'
        },
        {
          url: '/regioes',
          label: 'Regiões',
          isSpa: true
        },
        {
          label: 'Criar nova região'
        }
      ],
      /** Lista de hotéis para seleção */
      hotelsList: [],
      /** Título da página */
      pageTitle: 'Criar nova região',
      /** Nome da região (v-model) */
      regionName: '',
      /** Array que recebe os hotéis selecionados */
      selectedHotels: []
    }
  },
  computed: {
    disabledSave() {
      if (this.selectedHotels.length === 0 || this.regionName.trim() === '') {
        return true
      }
      return false
    }
  },
  async created() {
    this.$regions.getHotels().then((response) => {
      this.hotelsList = this.formatHotelsData(response.data)
    })
    /** Se tem o parâmetro, é edição */
    if (this.$route.params.id) {
      await this.$regions
        .getOneRegion(this.$route.params.id)
        .then((response) => {
          /** Recebe o objeto com os dados da região {ativo, codigo, hoteis[array] e nome} */
          const info = response.data
          this.regionName = info.nome
          this.pageTitle = 'Editando ' + this.regionName
          this.selectedHotels = info.hoteis.map((item) => {
            const obj = {}
            obj.id = item.codigo
            obj.text = item.nome
            return obj
          })
          this.breadcrumb[2].label = this.pageTitle
        })
    }
  },
  methods: {
    formatHotelsData(data) {
      const array = []
      data.forEach((hotel) => {
        array.push({
          id: hotel.codigo,
          text: hotel.nome
        })
      })
      return array
    },
    saveAction() {
      /** Se tem o parâmetro, atualiza uma região */
      if (this.$route.params.id) {
        const hotels = this.selectedHotels.map((item) => {
          return item.id
        })
        this.$regions
          .editRegion({
            nome: this.regionName,
            codigo: parseInt(this.$route.params.id),
            hoteis: hotels,
            ativo: true
          })
          .then(() => {
            this.$router.push({ path: '/regioes' })
            this.$bus.$emit('show-alert-chip', {
              message: 'Região salva'
            })
          })
          .catch((error) => {
            this.$bus.$emit('show-alert-chip', {
              message: error.messages
            })
          })
        /** Se não tem parâmetro, é criação de nova região */
      } else {
        const hotels = this.selectedHotels.map((item) => {
          return item.id
        })
        this.$regions
          .createRegion({
            nome: this.regionName,
            hoteis: hotels,
            ativo: true
          })
          .then(() => {
            this.$router.push({ path: '/regioes' })
            this.$bus.$emit('show-alert-chip', {
              message: 'Nova região criada'
            })
          })
          .catch((error) => {
            this.$bus.$emit('show-alert-chip', {
              message: error.messages
            })
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-title {
  padding-top: 35px;
  margin-left: 20px;
  margin-bottom: 15px;
}
.button {
  width: 215px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: auto;
}

.input {
  margin-bottom: 41px;
  &--title {
    padding-bottom: 6px;
  }
  &--box {
    width: 229px;
    height: $input-height;
    border: none;
    border-bottom: 1px solid $gray-darkest;
    outline: none;
    font-size: font-size('size-medium');
    &:focus {
      border-bottom: 1px solid $primary;
    }
  }
}
.bottom-action {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  max-width: 860px;
  &--button {
    width: 180px;
    &__save {
      width: 180px;
    }
  }
}
</style>
